import renewals from './renewals'

export default { renewals }
